import {
  BusinessCertifications,
  BusinessClients,
  BusinessInfo,
  BusinessRole,
  BusinessRSD,
  BusinessType
} from '../steppers';

const SwitchSteps = props => {
  // console.log('props ::>', props);
  // eslint-disable-next-line default-case
  switch (props.step) {
    case 0:
      return (
        <BusinessType
          values={props.values}
          errors={props.errors}
          touched={props.touched}
          onChange={props.handleChange}
          handleBlur={props.handleBlur}
          handleReset={props.handleReset}
          setFieldValue={props.setFieldValue}
          setFieldTouched={props.setFieldTouched}
          setFieldError={props.setFieldError}
          isSubmitting={props.isSubmitting}
        />
      );
    case 1:
      return (
        <BusinessRole
          values={props.values}
          errors={props.errors}
          touched={props.touched}
          onChange={props.handleChange}
          handleBlur={props.handleBlur}
        />
      );
    case 2:
      return (
        <BusinessInfo
          values={props.values}
          errors={props.errors}
          touched={props.touched}
          onChange={props.handleChange}
          handleBlur={props.handleBlur}
          setFieldValue={props.setFieldValue}
          setFieldTouched={props.setFieldTouched}
          setFieldError={props.setFieldError}
        />
      );
    case 3:
      return (
        <BusinessRSD
          setFieldValue={props.setFieldValue}
          values={props.values}
          errors={props.errors}
          touched={props.touched}
          onChange={props.handleChange}
          handleBlur={props.handleBlur}
          setFieldError={props.setFieldError}
        />
      );
    case 4:
      return (
        <BusinessCertifications
          values={props.values}
          errors={props.errors}
          touched={props.touched}
          setFieldValue={props.setFieldValue}
        />
      );
    case 5:
      return (
        <BusinessClients
          setFieldValue={props.setFieldValue}
          values={props.values}
          errors={props.errors}
          touched={props.touched}
          onChange={props.handleChange}
          handleBlur={props.handleBlur}
          setFieldTouched={props.setFieldTouched}
          setFieldError={props.setFieldError}
          setStep={props.setStep}
        />
      );

    case 6:
      return <div></div>;
  }
};

export { SwitchSteps };
